(function () {
  const MODAL_SELECTOR = '[id^="ProductModal-"].custom-gallery-modal';

  function getMediaId(node) {
    const raw = node.getAttribute('data-media-id') || '';
    return raw.split('-').pop();
  }

  function setupModal(modal) {
    if (modal.dataset.customGalleryReady === 'true') return;

    const dialog = modal.querySelector('.product-media-modal__dialog');
    const content = modal.querySelector('.product-media-modal__content');
    const closeButton = modal.querySelector('.product-media-modal__toggle');
    const stage = modal.querySelector('.custom-gallery__stage');
    const thumbsList = modal.querySelector('.custom-gallery__thumbs-list');
    const thumbButtons = Array.from(modal.querySelectorAll('.custom-gallery__thumb-btn[data-gallery-target]'));
    const thumbPrev = modal.querySelector('.custom-gallery__thumb-control--up');
    const thumbNext = modal.querySelector('.custom-gallery__thumb-control--down');
    const mediaItems = Array.from(stage ? stage.children : []).filter((item) => item.hasAttribute('data-media-id'));

    if (!dialog || !content || !closeButton || !stage || !thumbsList || !mediaItems.length) return;

    mediaItems.forEach((item) => item.classList.add('custom-gallery__item'));

    const state = { index: 0, touchStartX: 0, touchStartY: 0 };

    function pauseMedia() {
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    }

    function setActive(index) {
      if (!mediaItems.length) return;
      let next = index;
      if (next < 0) next = mediaItems.length - 1;
      if (next >= mediaItems.length) next = 0;
      state.index = next;

      const activeMediaId = getMediaId(mediaItems[next]);
      mediaItems.forEach((item, i) => item.classList.toggle('is-active', i === next));

      // bullets
      const currentBullet = document.querySelector('.custom-gallery__bullet.active');
      const targetBullet = document.querySelector('.custom-gallery__bullet[data-media-id="' + activeMediaId + '"]');
      if (currentBullet) {
        currentBullet.classList.remove('active');
      }
      if (targetBullet) {
        targetBullet.classList.add('active');
      }

      thumbButtons.forEach((btn) => {
        const isActive = btn.dataset.galleryTarget === activeMediaId;
        btn.classList.toggle('is-active', isActive);
        if (isActive) {
          btn.setAttribute('aria-current', 'true');
          btn.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        } else {
          btn.removeAttribute('aria-current');
        }
      });

      pauseMedia();
    }

    function setActiveByMediaId(mediaIdRaw) {
      const mediaId = (mediaIdRaw || '').split('-').pop();
      const found = mediaItems.findIndex((item) => getMediaId(item) === mediaId);
      setActive(found >= 0 ? found : 0);
    }

    thumbButtons.forEach((btn) => {
      btn.addEventListener('click', () => setActiveByMediaId(btn.dataset.galleryTarget));
    });

    if (thumbPrev) {
      thumbPrev.addEventListener('click', () => thumbsList.scrollBy({ top: -120, behavior: 'smooth' }));
    }
    if (thumbNext) {
      thumbNext.addEventListener('click', () => thumbsList.scrollBy({ top: 120, behavior: 'smooth' }));
    }

    function onKeydown(event) {
      if (!modal.hasAttribute('open')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(state.index - 1);
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(state.index + 1);
      }
    }

    function onTouchStart(event) {
      const t = event.touches[0];
      state.touchStartX = t.clientX;
      state.touchStartY = t.clientY;
    }

    function onTouchEnd(event) {
      const t = event.changedTouches[0];
      const dx = t.clientX - state.touchStartX;
      const dy = t.clientY - state.touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) setActive(state.index + 1);
      else setActive(state.index - 1);
    }

    stage.addEventListener('touchstart', onTouchStart, { passive: true });
    stage.addEventListener('touchend', onTouchEnd, { passive: true });
    document.addEventListener('keydown', onKeydown);

    const originalShow = modal.show.bind(modal);
    const originalHide = modal.hide.bind(modal);
    let closeAllowed = false;

    closeButton.addEventListener(
      'click',
      () => {
        closeAllowed = true;
      },
      true
    );

    modal.show = function (opener) {
      originalShow(opener);
      const openerMediaId = opener && opener.getAttribute ? opener.getAttribute('data-media-id') : '';
      setActiveByMediaId(openerMediaId);
    };

    modal.hide = function () {
      if (!closeAllowed) return;
      closeAllowed = false;
      pauseMedia();
      originalHide();
    };

    modal.__customGallerySetActiveByMediaId = setActiveByMediaId;
    modal.dataset.customGalleryReady = 'true';
    setActive(0);
  }

  function init() {
    document.querySelectorAll(MODAL_SELECTOR).forEach(setupModal);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);

  document.addEventListener('click', (event) => {
    const openerButton = event.target.closest('.product__media-toggle');
    if (!openerButton) return;

    const opener = openerButton.closest('modal-opener[data-modal]');
    if (!opener) return;

    const selector = opener.getAttribute('data-modal');
    if (!selector || selector.indexOf('#ProductModal-') !== 0) return;

    const modal = document.querySelector(selector);
    if (!modal) return;

    setupModal(modal);
    if (typeof modal.__customGallerySetActiveByMediaId === 'function') {
      modal.__customGallerySetActiveByMediaId(openerButton.getAttribute('data-media-id') || '');
    }
  });
})();
